import axios from 'axios'

const api = axios.create({
  baseURL: window.location.protocol === 'https:' ? process.env.REACT_APP_SERVER_URL : process.env.REACT_APP_SERVER_URL2,
  headers: {
    'Content-Type': 'application/json'
  }
})

export default api

